// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1362":"1e31735e08843fa8","2524":"61076df2355e1e27","3937":"08fefc3242242eac","4647":"9f95353cafd27d97","7113":"473d22c442f39852"}[chunkId] + ".css";
};